/* unplugin-vue-components disabled */import { useSettingsStore } from '@/store/modules/settings';
export default {
  __name: 'index',

  setup(__props, {
    expose
  }) {
    expose();
    const settingsStore = useSettingsStore();
    const {
      theme,
      logo,
      title
    } = storeToRefs(settingsStore);
    const __returned__ = {
      settingsStore,
      theme,
      logo,
      title,
      useSettingsStore
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }

};